import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import FreeTrialForm from '@/components/Pages/FreeTrial/FreeTrialForm'
import { NEAT_NO_CC_SKU, ORDER_SOURCE } from '@/constants'

import styles from './PopupSignUp.module.scss'

const PopupSignUp = ({
  postSlug = '',
  exitIntent = false,
  source = ORDER_SOURCE.NO_CC_TRIAL,
  planSku = NEAT_NO_CC_SKU,
}) => {
  const [showPopup, setShowPopup] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 1000 && !isDismissed) {
      setShowPopup(true)
    }
  }

  const handleMouseOut = (event) => {
    if (event.clientY < 10 && !isDismissed && exitIntent) {
      setShowPopup(true)
    }
  }

  const handleClose = () => {
    setShowPopup(false)
    setIsDismissed(true)
  }

  useEffect(() => {
    if (exitIntent) {
      document.addEventListener('mouseout', handleMouseOut)
    } else {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (exitIntent) {
        document.removeEventListener('mouseout', handleMouseOut)
      } else {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isDismissed, exitIntent])

  useEffect(() => {
    // Reset state variables when postSlug changes
    setShowPopup(false)
    setIsDismissed(false)
  }, [postSlug])

  return (
    <div>
      {showPopup && (
        <div className={styles.popupSignup}>
          <button className={styles.closePopupBtn} onClick={handleClose}>x</button>
          <div className={styles.popupContent}>
            <h3>Want more time to try Neat? Don't want to provide a credit card?</h3>
            <p>Trial Neat for 30-days, a smarter way to manage your receipts, documents, report expenses, and much more. Sign up now!</p>
          </div>
          <div className={styles.popupForm}>
            <div className={styles.popupFormWrap}>
              <FreeTrialForm planSku={planSku} source={source} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

PopupSignUp.propTypes = {
  postSlug: PropTypes.string,
  exitIntent: PropTypes.bool,
  source: PropTypes.string,
  planSku: PropTypes.string,
}

export default PopupSignUp
